import React, {FC} from 'react';

import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {LearnMoreButton as SharedLearnMoreButton} from '../../../../libs/shared/ui/src/components/buttons/learnMoreButton';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {openInBrowser} from '../../../../srcCommon/browser/openInBrowser';

/*
 * Props.
 */

export interface LearnMoreButtonProps {
  helpPageUrl: string;
  size?: VisualSizesEnum;
  variant?: ButtonVariantsEnum;
  className?: string;

  /**
   * Called along with openInBrowser when the button is clicked.
   * Specify this prop to add tracking to the button click.
   */
  onClick?: () => void;
}

/*
 * Component.
 */

/** @deprecated Use the `LearnMoreButton` presentational component from libs/shared instead. */
export const LearnMoreButton: FC<LearnMoreButtonProps> = ({
  helpPageUrl,
  size = VisualSizesEnum.MEDIUM,
  variant = ButtonVariantsEnum.SECONDARY,
  className,
  onClick,
}) => (
  <SharedLearnMoreButton
    size={size}
    variant={variant}
    onClick={() => {
      onClick?.();
      openInBrowser(helpPageUrl);
    }}
    className={className}
  />
);
